import { render, staticRenderFns } from "./WorkFooter.vue?vue&type=template&id=1947b832&"
import script from "./WorkFooter.vue?vue&type=script&lang=js&"
export * from "./WorkFooter.vue?vue&type=script&lang=js&"
import style0 from "./WorkFooter.vue?vue&type=style&index=0&id=1947b832&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports